import { render, staticRenderFns } from "./clientsList.vue?vue&type=template&id=6352fb9d&"
import script from "./clientsList.vue?vue&type=script&lang=js&"
export * from "./clientsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports